/*
 * The tabs of Settings (issue #66), and the address of each. A link from
 * another screen names the tab its sentence is about -- "Record the Deposit
 * Schedule" opens Payroll, "reopen it in Settings" opens Books -- so it lands
 * on the section rather than at the top of a page of tabs.
 */
export type SettingsTab = 'business' | 'banks' | 'books' | 'payroll' | 'security' | 'data';

/** The address of a Settings tab. */
export function settingsTab(tab: SettingsTab): string {
  return `/settings?tab=${tab}`;
}
